import React from 'react';
import ContentLayout from '../../layout/contentLayout';
import styles from './scss/modifywhatsapp.module.scss';

const ModifyWhatsapp = () => {
    return (
        <div className={styles.whatsappsec}>
            <div className={styles.templatewrapper}>

                <div className={styles.templatesec}>
                    <div className={styles.prevtep}>

                    </div>
                    <p className={styles.tempname}>Template 1</p>
                    <button className={`cancelbtn ${styles.btns}`}>Select</button>
                </div>
               
            </div>
             {/* <div className={styles.titlebasegoal}>
                    <h3>Title</h3>
                    <p>Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed Based on Campaign Goal & Objective, Approved Templates from settings is listed</p>
                    <h4>Create New template</h4>
                </div> */}
            <button className='cancelbtn'>Back</button>
        </div>
    )
}

export default ModifyWhatsapp
